// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"M9ttERGucC0kjAalrrA5","header":"OPZAczEa7A1j6WgGRJFw","left":"yF06ti_KiVEoM5uQEr9Q","right":"ZHPyp_GxzaxKbAe6GDoR","avatar":"J7McHIo4AyMsh4W3FCTe"};